module.exports = {
  title: 'Resto',
  description: 'Where restaurants are managed',
  max_upload_size_per_file: 2 * 1024 * 1024,
};
